module.exports = "/images/3ef745c227a6317603ba3274010f61d6.jpg";